export const isHtmlVideoElement = (
  element: HTMLElement | null,
): element is HTMLVideoElement => element?.tagName === 'VIDEO';
